import Navbar from "../components/Navbar";
import data from "../language.json";
import React, { useContext, useState } from "react";
import languageContext from "../context/language/languageContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Profile = () => {
  const { lang } = useContext(languageContext);
  const navigate = useNavigate();
  const [details, setDetails] = useState({
    nurse_name: "",
    center_hospital: "",
    city: "",
    state: "",
    under_dr_name: "",
    department: "",
  });

  // Update state with new values
  const handleChange = (e, field) => {
    setDetails((prevDetails) => ({
      ...prevDetails,
      [field]: e.target.value,
    }));
  };

  const submitProfile = async () => {
    try {
      const headerList = {
        Accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      const response = await axios.post(
        "https://www.careplus.gopillz.com/nurse_sigup_details",
        { data: details },
        { headers: headerList }
      );
      console.log("Profile submitted successfully:", response.data.msg);
      navigate("/ask"); // Navigate after successful submission
    } catch (error) {
      console.error("Error saving the details: ", error);
      alert("Could not save your data, please try again later.");
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <Navbar />
      <div className="flex justify-center px-4">
        <div className="w-full sm:w-10/12 lg:w-7/12 xl:w-6/12 p-6 mt-6 bg-white shadow-md rounded-lg">
          {/* Header */}
          <h2 className="text-2xl font-bold text-center mb-6 text-gray-700">
            Nurse Profile Setup
          </h2>

          {/* Profile Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {data[lang]["nurse"].map((item, index) => (
              <div key={index}>
                <label className="block text-[16px] text-gray-700 mb-2">
                  {item.name}
                </label>
                <input
                  type="text"
                  required
                  className="w-full px-4 py-2 border rounded-lg bg-gray-50 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  value={details[item.value]}
                  onChange={(e) => handleChange(e, item.value)}
                  placeholder={`Enter ${item.name}`}
                />
              </div>
            ))}
          </div>

          {/* Submit Button */}
          <div className="flex justify-center mt-6">
            <button
              type="button"
              className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition-all"
              onClick={submitProfile}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
